import { Countries } from '../models/countries'

const stripGovId = (govId, countryCode) => {
  if (govId) {
    let id = govId
    switch (countryCode) {
      case Countries.SE:
        id = id.replace('-', '')
        if (id.length > 10) {
          id = id.substring(2, id.length)
        }
        break
      case Countries.DK:
        id = id.replace('-', '')
        break
      default:
        break
    }
    return id
  }
  return null
}

// govIdComparison should return true if the two govIds are unique
export const govIdComparison = (coapp, main, countryCode = Countries.SE) => {
  let unique = true
  if (stripGovId(coapp, countryCode) === stripGovId(main, countryCode)) {
    unique = false
  }
  return unique
}
